/**
 * @description 添加应用能力
 * @param {object} param
 * @param {string} param.appId 应用id
 * @param {'wecode'|'h5'|'robot'} param.abilityType 应用能力类型
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 */
export const doAddAbility = (param, type) => {
  const { appId, abilityType } = param;
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/${type}/ability/${appId}`,
    {
      method: "POST",
      body: JSON.stringify({ abilityType: [abilityType] })
    }
  );
};
